import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import FloatingCTA from "./components/feature/FloatingCTA";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="relative min-h-screen bg-abyss-900">
          <Navbar />
          <main>
            <AppRoutes />
          </main>
          <Footer />
          <FloatingCTA />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
